
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jakearnold-for-parachute",
      function () {
        return require("private-next-pages/jakearnold-for-parachute/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jakearnold-for-parachute"])
      });
    }
  